import React from "react";
import { Link } from "react-router-dom";
import { ColorPicker, getDarkerColor } from "components/vmisc/onboarding/Onboarding.sub.colorpicker.view";
import { AREAS } from "components/vmisc/onboarding/GetStarted.lib.catalogs";
import Templates from "components/vmisc/templates/Templates";

const HomeOnboardingView = ({
  step,
  values,
  back,
  next,
  finish,
  processOptions,
  otherProcess,
  totalSteps,
  area,
  processes,
  percent,
  loading,
  error,
  toggleProcess,
  setValues,
  setArea,
  canNext,
  onSelectFlowTemplate,
  setOtherProcess
}) => (
  <div className="container-fluid px-0">
    <div className="row">
      <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center min-vh-lg-100 position-relative px-0 ">

       

        <div className="position-absolute top-0 right-0 left-0 bg-img-hero w-100 h-100"
          id="background-hero">

          <figure className="position-absolute top-0 right-0 left-0 overflow-hidden">
            <svg preserveAspectRatio="none" viewBox="0 0 1920 698" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(270)"
              style={{
                height: "132vh",
                width: "132vh",
              }}>
              <rect width="1920" height="698" fill="#fff" />
              <g clipPath="url(#clip0)">
                <path className="path-a" d="M1920 -714.403H0V1412.4H1920V-714.403Z" fill="#2065a5" />
                <path className="path-b" d="M1298.9 -5488.72L2618.5 1300.02L1702.8 1842.02C1651.6 1690.56 1569.6 1565.26 1479.9 1480.46C1338.1 1346.44 1176.9 1292.52 1020.9 1221.67C933 1182.06 832 1111.56 811.9 957.132C799 858.54 824.8 759.075 837.2 660.308C869.8 400.128 798.7 110.284 668.3 -28.0949C635.9 -62.4714 599.1 -90.391 577.4 -144.661C510.4 -312.18 639.3 -526.467 627 -729.759C622.6 -803.224 599.6 -869.01 574.6 -928.689C300.4 -1585.86 -209.4 -1749.54 -628.8 -2103.6C-751.2 -2207.08 -871.1 -2334.11 -955 -2520.83C-1038.9 -2707.72 -1081.4 -2964.58 -1036.1 -3188.29C-974.1 -3494.19 -776.5 -3644.26 -593.7 -3703.76C-410.9 -3763.27 -215.6 -3771.47 -56 -3937.77C117.6 -4118.72 216 -4451.32 351 -4713.77C418.6 -4845.17 495.6 -4958.94 577.8 -5061.9L1298.9 -5488.72Z" fill="#205595" />
                <path className="path-c" d="M1733.2 -6299.97L3053 487.553L2137.2 1029.55C2086 878.084 2004 752.968 1914.3 668.161C1772.5 534.145 1611.3 480.224 1455.2 409.552C1367.3 369.766 1266.3 299.443 1246.2 145.01C1233.4 46.4176 1259.2 -53.0476 1271.5 -151.815C1304.1 -411.994 1233 -701.664 1102.6 -840.217C1070.2 -874.594 1033.4 -902.514 1011.7 -956.783C944.7 -1124.3 1073.6 -1338.59 1061.3 -1541.71C1056.9 -1615.17 1033.8 -1680.96 1008.9 -1740.64C734.8 -2397.63 224.9 -2561.31 -194.5 -2915.37C-316.9 -3018.85 -436.8 -3145.71 -520.7 -3332.6C-604.6 -3519.32 -647.1 -3776.18 -601.8 -3999.89C-539.8 -4305.61 -342.2 -4455.86 -159.4 -4515.36C23.3999 -4574.87 218.7 -4583.07 378.3 -4749.37C551.8 -4930.15 650.2 -5262.75 785.2 -5525.02C852.8 -5656.42 929.8 -5770.19 1012 -5873.15L1733.2 -6299.97Z" fill="#104a8a" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="1920" height="698" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </figure>

        </div>

         <div class="position-absolute top-0 left-0 right-0 mt-4 mx-5">
          <div class="d-none d-lg-flex justify-content-between">
            <a href="/">
              <img class="w-100" src="/theme/svg/logos/logo-white.svg"
                alt="Workix logo" style={{ minWidth: "10rem", maxWidth: "10rem" }} />
            </a>
          </div>
        </div>

      </div>

      <div className="col-lg-8 d-flex justify-content-center align-items-center min-vh-lg-100">
        <div className="w-100 pt-10 pt-lg-7 pb-7" style={{ maxWidth: "60rem" }}>

          <div className="text-center mb-5">
            <h1 className="display-4">¡Bienvenido a Workix!</h1>
            <p>Transforma tu organización con inteligencia artificial</p>
          </div>

          <div className="card">

            <div className="card-header mb-2 pb-0">
              {/* Progress */}
              <div className="mb-4 w-100">
                <div className="d-flex justify-content-between mb-1">
                  <small className="text-muted">Progreso</small>
                  <small className="text-muted">{step} de {totalSteps}</small>
                </div>
                <div className="progress" style={{ height: 6 }}>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${percent}%` }}
                    aria-valuenow={percent}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
            </div>

            <div className="card-body">
              {step === 1 && (
                <>
                  <h3 className="mb-3 text-center">¿A qué te dedicas?</h3>
                  <div className="form-group">
                    <label className="mb-1">Selecciona una opción para personalizar tu experiencia</label>
                    <select
                      className="form-control mb-3"
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      required
                    >
                      <option value="">Selecciona un área</option>
                      {AREAS.map((area) => (
                        <option key={area} value={area}>{area}</option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              {step === 2 && (
                <>
                  <h3 className="mb-2 text-center">¿Qué proceso te gustaría optimizar?</h3>
                  <p className="text-muted mb-4 text-center">Puedes seleccionar uno o varios.</p>
                  <div className="row">
                    {processOptions.map((opt) => (
                      <div className="col-sm-6 col-md-4 mb-2" key={opt.value}>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            id={`proc_${opt.value}`}
                            className="custom-control-input"
                            checked={processes.includes(opt.value)}
                            onChange={() => toggleProcess(opt.value)}
                          />
                          <label className="custom-control-label" htmlFor={`proc_${opt.value}`}>
                            {opt.label}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                  {processes.includes("other") && (
                    <div className="form-group mt-3">
                      <label>Describe el proceso “Otro”</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ej. Gestión de franquicias"
                        value={otherProcess}
                        onChange={(e) => setOtherProcess(e.target.value)}
                      />
                    </div>
                  )}
                </>
              )}

              {step === 3 && (
                <>
                  <h3 className="mb-2 text-center">Ahora selecciona los colores para Workix</h3>
                  <p className="text-muted mb-4 text-center">Lo usaremos para personalizar tu tema.</p>
                  <div className="row mx-0">
                    <div className="col-md-8 p-0">
                      <div className="bg-img-hero"
                        style={{
                          pointerEvents: "none",
                          height: "15rem"
                        }}>

                        <figure style={{ height: "100%" }}>
                          <svg preserveAspectRatio="none" viewBox="0 0 1920 698" fill="none" xmlns="http://www.w3.org/2000/svg"
                            style={{
                              height: "100%",
                              width: "100%",
                            }}>
                            <rect width="1920" height="698" fill="#fff" />
                            <g clipPath="url(#clip0)">
                              <path className="path-a" d="M1920 -714.403H0V1412.4H1920V-714.403Z" fill={values?.primaryColor ? getDarkerColor(values?.primaryColor, -30) : getDarkerColor("#2080e5", -30)} />
                              <path className="path-b" d="M1298.9 -5488.72L2618.5 1300.02L1702.8 1842.02C1651.6 1690.56 1569.6 1565.26 1479.9 1480.46C1338.1 1346.44 1176.9 1292.52 1020.9 1221.67C933 1182.06 832 1111.56 811.9 957.132C799 858.54 824.8 759.075 837.2 660.308C869.8 400.128 798.7 110.284 668.3 -28.0949C635.9 -62.4714 599.1 -90.391 577.4 -144.661C510.4 -312.18 639.3 -526.467 627 -729.759C622.6 -803.224 599.6 -869.01 574.6 -928.689C300.4 -1585.86 -209.4 -1749.54 -628.8 -2103.6C-751.2 -2207.08 -871.1 -2334.11 -955 -2520.83C-1038.9 -2707.72 -1081.4 -2964.58 -1036.1 -3188.29C-974.1 -3494.19 -776.5 -3644.26 -593.7 -3703.76C-410.9 -3763.27 -215.6 -3771.47 -56 -3937.77C117.6 -4118.72 216 -4451.32 351 -4713.77C418.6 -4845.17 495.6 -4958.94 577.8 -5061.9L1298.9 -5488.72Z" fill={values?.primaryColor ?? "#2080e5"} />
                              <path className="path-c" d="M1733.2 -6299.97L3053 487.553L2137.2 1029.55C2086 878.084 2004 752.968 1914.3 668.161C1772.5 534.145 1611.3 480.224 1455.2 409.552C1367.3 369.766 1266.3 299.443 1246.2 145.01C1233.4 46.4176 1259.2 -53.0476 1271.5 -151.815C1304.1 -411.994 1233 -701.664 1102.6 -840.217C1070.2 -874.594 1033.4 -902.514 1011.7 -956.783C944.7 -1124.3 1073.6 -1338.59 1061.3 -1541.71C1056.9 -1615.17 1033.8 -1680.96 1008.9 -1740.64C734.8 -2397.63 224.9 -2561.31 -194.5 -2915.37C-316.9 -3018.85 -436.8 -3145.71 -520.7 -3332.6C-604.6 -3519.32 -647.1 -3776.18 -601.8 -3999.89C-539.8 -4305.61 -342.2 -4455.86 -159.4 -4515.36C23.3999 -4574.87 218.7 -4583.07 378.3 -4749.37C551.8 -4930.15 650.2 -5262.75 785.2 -5525.02C852.8 -5656.42 929.8 -5770.19 1012 -5873.15L1733.2 -6299.97Z" fill={values?.accentColor ?? "#f0b000"} />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="1920" height="698" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </figure>
                      </div>
                    </div>
                    <div className="col-md-4 p-0">
                      <div className="d-flex h-100 w-100 justify-content-center align-items-center">
                        <div>
                          <ColorPicker
                            label={"Color principal"}
                            name="primaryColor"
                            values={values}
                            defaultColor={"#2065a5"}
                            setFieldValue={(field, value) => setValues(prev => ({ ...prev, [field]: value }))}
                          />

                          <ColorPicker
                            label={"Color de acento"}
                            name="accentColor"
                            values={values}
                            defaultColor={"#f0b000"}
                            setFieldValue={(field, value) => setValues(prev => ({ ...prev, [field]: value }))}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {step == 4 && (
                <>
                  <h3 className="mb-3 text-center">Crea tu primer proceso</h3>
                  <Templates onSelectFlowTemplate={onSelectFlowTemplate} />
                </>
              )}

              {error && (
                <div className="alert alert-danger mt-3" role="alert">
                  {error}
                </div>
              )}
            </div>

            <div className="card-footer d-flex justify-content-between align-items-center">
              <button
                className="btn btn-link"
                onClick={back}
                disabled={step === 1 || loading}
              >
                Atrás
              </button>

              <div>
                {step < totalSteps ? (
                  <button
                    className="btn btn-primary"
                    onClick={next}
                    disabled={!canNext() || loading}
                  >
                    Siguiente
                  </button>
                ) : (
                  <button
                    className="btn btn-primary"
                    onClick={finish}
                    disabled={!canNext() || loading}
                  >
                    {loading ? "Finalizando…" : "Finalizar"}
                  </button>
                )}
              </div>
            </div>

          </div>

          <div className="mt-4">
            <small className="text-muted">
              ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
)

HomeOnboardingView.propTypes = {};

export default HomeOnboardingView;